// Carousel js
$(function() {
  const $carousel = $('.owl-carousel_auto-control');
  if (!$carousel.length) return;

  const totalItems = $carousel.find('.item').length;
  
  const itemsPerSlide = 4;
  const itemsToScroll = 4;

  // Cache navigation buttons for better performance
  let $navButtons;

  // Get current items visible based on screen width
  function getCurrentItemsVisible() {
    const width = $(window).width();
    if (width >= 1600) return itemsPerSlide; // 4 items
    if (width >= 1280) return 3;
    if (width >= 992) return 2;
    return 1;
  }

  // Get current slideBy value based on screen width (matches responsive config)
  function getCurrentSlideBy() {
    const width = $(window).width();
    if (width >= 1750) return itemsToScroll; // 4
    if (width >= 1600) return 3;
    if (width >= 1400) return 3;
    if (width >= 1140) return 2;
    return 1; // Mobile and small screens
  }

  // Smart Navigation Controls
  function updateControls() {
    const api = $carousel.data("owlCarousel");
    if (!api) return;

    let current = 0, min = 0, max = 0;

    // Get current position based on Owl Carousel API version
    if (api.pos && api.pos.current !== undefined) {
      current = api.pos.current;
      min = api.pos.min;
      max = api.pos.max;
    } else if (api.currentItem !== undefined) {
      current = api.currentItem;
      min = 0;
      max = api.maximumItem;
    } else {
      current = api.currentItem || 0;
      min = 0;
      max = api.itemsAmount ? api.itemsAmount - 1 : 0;
    }

    // Get current visible items based on screen size
    const currentVisibleItems = getCurrentItemsVisible();
    // Get current slideBy value based on screen size
    const currentSlideBy = getCurrentSlideBy();

    // Calculate remaining items for smart scrolling
    const remainingForward = totalItems - (current + currentVisibleItems);
    const remainingBackward = current;

    // Adjust slideBy at edges to prevent empty space
    if (remainingForward > 0 && remainingForward < currentSlideBy) {
      api.options.slideBy = remainingForward;
    } else if (remainingBackward > 0 && remainingBackward < currentSlideBy) {
      api.options.slideBy = remainingBackward;
    } else {
      api.options.slideBy = currentSlideBy;
    }

    // Cache nav buttons on first run
    if (!$navButtons) {
      $navButtons = {
        prev: $carousel.find(".owl-prev"),
        next: $carousel.find(".owl-next")
      };
    }

    // Enable/disable navigation buttons
    $navButtons.prev
      .toggleClass("disabled", current <= min)
      .attr("aria-disabled", current <= min);

    $navButtons.next
      .toggleClass("disabled", current >= max)
      .attr("aria-disabled", current >= max);
  }

  // If fewer items than visible at current screen size, disable navigation
  const currentVisibleItems = getCurrentItemsVisible();
  if (totalItems <= currentVisibleItems) {
    $carousel.addClass("owl-loaded")
      .find(".owl-prev, .owl-next")
      .addClass("disabled")
      .attr("aria-disabled", "true");
    return;
  }

  // Better Responsive Configuration
  const navArrowSvg = "<svg><use xlink:href='/dist/img/svg-sprite.svg#sorting-arrow-table'></use></svg>";
  const carouselOptions = {
    responsiveClass: true,
    loop: false,
    autoplay: true,
    autoplayHoverPause: true,
    items: itemsPerSlide,
    slideBy: itemsToScroll,
    nav: true,
    dots: false,
    margin: 20,
    stagePadding: 0,
    navText: [navArrowSvg, navArrowSvg],
    responsive: {
      0: { items: 1, slideBy: 1 },
      620: { items: 1, slideBy: 1 },
      1140: { items: Math.min(2, itemsPerSlide || 1), slideBy: 2 },
      1400: { items: Math.min(3, itemsPerSlide || 1), slideBy: 3 },
      1600: { items: Math.min(3, itemsPerSlide || 1), slideBy: 3 },
      1750: { items: itemsPerSlide || 1, slideBy: itemsToScroll || 1 },
    },
    afterInit: updateControls,
    afterAction: updateControls,
    afterUpdate: updateControls
  };

  // Initialize carousel
  $carousel.owlCarousel(carouselOptions);

  // Enhanced click handlers for better control updates
  $carousel.on("click.owlAutoControl mouseup.owlAutoControl touchend.owlAutoControl", ".owl-prev, .owl-next", () => {
    setTimeout(updateControls, 40);
  });

  // Ensure controls update after window load
  $(window).on("load.owlAutoControl", () => setTimeout(updateControls, 120));

  // Initial control update
  setTimeout(updateControls, 0);
});